import { Component } from '@angular/core';

@Component({
  selector: 'app-eye-close-icon-svg',
  templateUrl: './eye-close-icon-svg.component.html',
  styleUrl: './eye-close-icon-svg.component.scss'
})
export class EyeCloseIconSvgComponent {

}
